<template>
  <div class="dui-option-picker">
    <slot name="options" />
    <span
      v-for="(option, index) in vm.options"
      :key="index"
      class="option"
      :class="{ 'selected': option.selected }"
      :title="option.text"
      @click="selectOption(option)"
    >
      {{ option.text }}
      <DuiIconTick class="icon-sm" />
    </span>
  </div>
</template>

<script>
import storeKey from '@dui/mixins/store-key';

function _getOptionByValue(options, value) {
  if (typeof value === 'undefined' || value === null) {
    return null;
  }

  return options.find(o => o.value.toString() === value.toString());
}

function _getOptionsFromElement(parentEl) {
  const options = [];

  const optionEls = parentEl.querySelectorAll('.dui-option');
  [].forEach.call(optionEls, (optionEl) => {
    const option = {
      text: optionEl.dataset.text,
      value: optionEl.dataset.value,
    };

    optionEl.remove();
    options.push(option);
  });

  return options;
}

export default {
  mixins: [
    storeKey,
  ],
  props: {
    value: {
      type: [ Number, String ],
      default: null,
    },
  },
  data: () => ({
    vm: {
      options: null,
      selectedOption: null,
    },
  }),
  computed: {
    storeOptions() {
      return this.loadFromStore();
    },
  },
  mounted() {
    this.setInitialOptions();
    this.preSelectOption();
  },
  methods: {
    deselectOption() {
      if (!this.vm.selectedOption) {
        return;
      }

      this.$set(this.vm.selectedOption, 'selected', false);
      this.vm.selectedOption = null;
      this.updateExternalValue();
    },

    preSelectOption() {
      const option = _getOptionByValue(this.vm.options, this.value);
      if (!option) {
        return;
      }

      this.selectOption(option);
    },

    selectOption(option) {
      if (this.vm.selectedOption === option) {
        this.deselectOption();
        return;
      }

      if (this.vm.selectedOption) {
        this.$set(this.vm.selectedOption, 'selected', false);
      }

      this.$set(option, 'selected', true);
      this.vm.selectedOption = option;
      this.updateExternalValue();
    },

    setInitialOptions() {
      if (this.storeOptions) {
        this.vm.options = this.storeOptions;
        return;
      }

      this.$set(this.vm, 'options', _getOptionsFromElement(this.$el));
    },

    updateExternalValue() {
      const selectedValue = this.vm.selectedOption ? this.vm.selectedOption.value : null;

      this.$emit('input', selectedValue);
      this.$emit('change');

      if (!this.storeUpdateKey) {
        return;
      }

      this.$store.dispatch(this.storeUpdateKey, this.vm.selectedOption);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-option-picker {
  background: getColor($white);
  border: $border-width-base solid getColor($grey, fade);
  border-radius: $border-radius-base;
  box-sizing: border-box;
  overflow: hidden;

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  .option {
    cursor: pointer;
    display: block;
    padding: $_1em $_4em $_1em $_1-5em;
    position: relative;

    .dui-icon {
      opacity: 0;
      pointer-events: none;
      position: absolute;
      right: $_2em;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;

      @include transition((
        opacity
      ));
    }

    @include ellipsis();

    @include transition((
      background-color
    ));

    &:hover {
      background-color: getColor($grey);
    }

    &.selected {
      background-color: getColor($yellow, fade);

      .dui-icon {
        opacity: 1;
      }
    }
  }
}
</style>
